
import { MapTo } from '@adobe/aem-react-editable-components';
import MidPageNavigationIcons, { MidPageNavigationIconsEditConfig } from './MidPageNavigationIcons';

export default MapTo('cob-corp-acquisition/components/creditonebank/mid-page-navigation-icons')(MidPageNavigationIcons, MidPageNavigationIconsEditConfig);
        